import { useQuery } from "@tanstack/react-query"
import pipelinesAdminService from "services/admin/pipelinesAdminService"

export const useGetPipelines = (orgID: string, type: string): any => {
    return useQuery({
        queryKey: ['pipelines', orgID, type],
        queryFn: async () => {
            const response: any = await pipelinesAdminService.getAll({ orgID, type })
            return response?.data || []
        },
    })
}